import React from "react";
import { ReactComponent as Spinner } from "../../assets/img/spinner.svg";

const Loader = () => (
  <div className="loader-spinner d-flex justify-content-center align-items-center">
    <Spinner alt="loading" />
  </div>
);

export default Loader;
